
import MenuItem from "../Menu/MenuItem";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIsOpenSidebar, useIsOpenSidebarAction } from "../../context/toggleSidebarContext";
import { useEffect, useState } from "react";
import data from "../../mockData/menuPublic.json";
import Restricted from "../../context/Restricted";
import { logout } from "../../services";
import { activeLink } from "../../utils/activeLink";
// import {useAuth} from "../../context/AuthContext";
import { useSweetAlert } from "../../context/sweetAlertContext";
import RulesModal from "../Modals/RulesModal";

export default function SidebarPublic() {
    const [isOpenRules, setIsOpenRules] = useState(false);
    const [selectedParent, setSelectedParent] = useState(null);
    const { pages } = data;
    const setIsOpenSidebar = useIsOpenSidebarAction();
    const isOpenSidebar = useIsOpenSidebar();
    const route = useLocation()
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    // const auth = useAuth();
    const sweetAlert = useSweetAlert()

    const handleHoverSidebar = () => {

        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: true })
        }
    }
    const Logout = async () => {

        sweetAlert({
            show: true,
            title: "خروج از حساب کاربری",
            icon: 'warning',
            showCancelButton: true,
            text: `آیا میخواهید از حساب خود خارج شوید؟`,
            confirmButtonText: "تایید",
            cancelButtonText: "خیر",
            onConfirm: () => handleLogout(),
        })

    }
    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const { isSuccess } = await logout();
            if (isSuccess) {
                const html = document.querySelector('html');

                html.className = '';

                navigate('/login')
            }
            setIsLoading(false)
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    }
    useEffect(() => {
        setSelectedParent(route.pathname.split("/")[1]);
    }, [route.pathname])

    const handleBlurSidebar = () => {
        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: false })
        }
    }

    useEffect(() => {
        if (isOpenSidebar.collapsed) {
            if (isOpenSidebar.expanded) {
                setIsOpenSidebar({ ...isOpenSidebar, expanded: false })
            }
        }
    }, [route.pathname])

    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme"
            onMouseEnter={handleHoverSidebar} onMouseLeave={handleBlurSidebar}>
            <div className="app-brand demo">

                {/*<Link to="/" className={`app-brand-link mx-auto ${isOpenSidebar.collapsed && !isOpenSidebar.expanded && !isOpenSidebar.hovered ? "ms-n4" : ""}`}>*/}
                {/*    <span className="app-brand-logo demo">*/}
                {/*         <img src="/logo.png" alt="logo"/>*/}
                {/*      </span>*/}
                {/*    /!*<span className="app-brand-text demo menu-text fw-bold ms-2 display-8">آجیل برادران حسینی</span>*!/*/}
                {/*</Link>*/}

                <button className="layout-menu-toggle bg-transparent border-0 menu-link text-large ms-auto">
                    <i className="bx menu-toggle-icon d-none d-xl-block fs-4 align-middle"
                        onClick={() => setIsOpenSidebar({ ...isOpenSidebar, collapsed: !isOpenSidebar.collapsed })} />
                    <i className="bx bx-x d-block d-xl-none bx-sm align-middle"
                        onClick={() => setIsOpenSidebar({ ...isOpenSidebar, expanded: false })} />
                </button>
            </div>
            <div className="menu-divider mt-0" />

            <div className="menu-inner-shadow" />
            <div className="user-profile"><img

                src="/icons/user.png" />
            </div>
            <div className="user-info">
                <h6 className="user-name mb-1">
                    کاربر میهمان
                </h6>
            </div>
            <ul className="menu-inner py-1">
                {
                    pages && pages.length > 0 && pages.map(item => {
                        return (
                            <MenuItem
                                key={item.id} // <--- این خط اضافه شد تا خطای Key برطرف شود
                                item={item}
                                onClick={() =>
                                    navigate("/login")
                                } />
                        )
                    })
                }

                <li className="menu-item menu-item-animating">
                    {/* خروج از حساب */}
                    {/* <button className="menu-link w-100 border-0 text-danger" onClick={() => Logout()}>
                        <i className="menu-icon tf-icons bx bx-log-out text-danger" />
                        <div>خروج از حساب کاربری</div>
                    </button> */}

                    {/* لینک قوانین و مقررات */}
                    <button
                        className="menu-link w-100 border-0 text-primary mb-1"
                        onClick={() => setIsOpenRules(true)}
                    >
                        <i className="menu-icon tf-icons bx bx-file-text" />
                        <div>قوانین و مقررات</div>
                    </button>
                    {/* ورژن اپ */}
                    <p className="text-center font-11">App Version: {process.env.REACT_APP_VERSION}</p>
                </li>

            </ul>
            <RulesModal
                isOpen={isOpenRules}
                setIsOpen={setIsOpenRules}
            />

        </aside>
    )
}